export default "__VITE_ASSET__CV56uky6__"